import React, { useState } from "react";
import useStyles from "../../../../components/common/model/styles";
import Popup from "../../../../components/common/model/Popup";
import CustomButton from "../../../../components/common/button/CustomButton";
import closeIcon from "../../../../assets/closeModel.png";
import { Alert, DialogContent, DialogContentText } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { cancelSurveyAction } from "../../../../store/reducers/leadSurveySlice";

interface AlertCancelSurveyPopupProps {
  title?: string;
  open: boolean;
  onHide?: () => void;
  setFormData?: any;
  formData?: any;
  alertModalShow: boolean;
  setAlertModelShow: (show: boolean) => void;
  setShowSuccessMessage?: (message: string) => void;

}
const AlertCancelSurvey: React.FC<AlertCancelSurveyPopupProps> = ({
  onHide,
  title,
  alertModalShow,
  setAlertModelShow,

}) => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { userProfile } = useSelector((state: any) => state.user);
  const classes = useStyles();
  const dispatch = useDispatch();
  const closeModel = () => {
    setAlertModelShow(false);
  };
  
  const submitHandler = () => {
    const leadData = leadDetails?.lead;
    const roleType = userProfile?.roles?.includes("Surveyor") ? "Surveyor" : "Admin";
    dispatch(cancelSurveyAction({ ...leadData, type: roleType }));
  }

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("xs"); // Adjust the type definition

  return (
    <>
      <Popup
        open={alertModalShow}
        title={"Cancel Survey?"}
        onHide={closeModel}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={closeModel}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton variant="outlined" title="No" onClick={closeModel} />
            <CustomButton title="Yes" onClick={submitHandler} />
          </>
        }
      >
        <DialogContent sx={{ padding: "0px" }}>
          <DialogContentText>
            <Alert
              sx={{ bgcolor: "#eeecef", fontSize: "16px" }}
              severity="warning"
            >
              Are you sure you want to cancel the survey?
            </Alert>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default AlertCancelSurvey;
